import UI from '../../components/ExcerciseTypes/Design/UserInterface';


const json = {
  1: { // Exercise num
    unit: 'Starter',
    id: 'SB5-V2-S-P6-E1',
    audio: 'img/FriendsPlus/Page6/Audio/audio-e1-p6.mp3',
    video: '',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page6/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page6/E1/3.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/tieude-e1-p6.mp3' },
        { url: 'img/FriendsPlus/Page6/E1/4.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page6/E1/5.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/t1.mp3' },
        { url: 'img/FriendsPlus/Page6/E1/6.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/t2.mp3' },
        { url: 'img/FriendsPlus/Page6/E1/7.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/t3.mp3' },
        { url: 'img/FriendsPlus/Page6/E1/8.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/t4.mp3' },
        { url: 'img/FriendsPlus/Page6/E1/9.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/t5.mp3' },
        { url: 'img/FriendsPlus/Page6/E1/10.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/t6.mp3' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page6/E1/11.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/t7.mp3' },
        { url: 'img/FriendsPlus/Page6/E1/12.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/t8.mp3' },
        { url: 'img/FriendsPlus/Page6/E1/13.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/t9.mp3' },
        { url: 'img/FriendsPlus/Page6/E1/14.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/t10.mp3' },
        { url: 'img/FriendsPlus/Page6/E1/15.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/t11.mp3' },
        { url: 'img/FriendsPlus/Page6/E1/16.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/t12.mp3' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Starter',
    id: 'SB5-V2-S-P6-E2',
    audio: 'img/FriendsPlus/Page6/Audio/audio-e2-p6.mp3',
    video: '',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page6/E2/18.jpg' },
        { url: 'img/FriendsPlus/Page6/E2/19.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/tieude-e2-p6.mp3' },
        { url: 'img/FriendsPlus/Page6/E2/20.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page6/E2/21.jpg' },
      ]
    ],
  },
}

export default json;